(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('ReasonCodeDeleteController',ReasonCodeDeleteController);

    ReasonCodeDeleteController.$inject = ['$uibModalInstance', 'entity', 'ReasonCode'];

    function ReasonCodeDeleteController($uibModalInstance, entity, ReasonCode) {
        var vm = this;

        vm.reasonCode = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ReasonCode.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
